import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  Menu,
  Package2,
  X,
  Rocket,
  UserPlus,
  DollarSign,
} from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../components/ui/dropdown-menu";

import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Sheet, SheetContent, SheetTrigger } from "../components/ui/sheet";
import moment from "moment";

const Navbar = ({ app, reloadStuffs }) => {
  const navigate = useNavigate();
  const [sidebar, setSidebar] = useState(false);
  const [valid_till, setValidTill] = useState("");
  const [is_valid_tenant, setIsValidTenant] = useState(false);

  useEffect(() => {}, reloadStuffs)

  // Function to fetch tenant expiry info
  async function getExpiryInfo() {
    const tenantId = localStorage.getItem("tenantId");
    const api = `https://backend-4ismwsd.cloud-serverless.run/sites/get-with-tenant/${tenantId}`;
    try {
      const response = await fetch(api);
      const json = await response.json();

      if (!json.url) {
        setIsValidTenant(false);
        return;
      }

      const date = new Date(json.expires * 1000);
      const daysRemaining = moment(date).diff(moment(), 'days');
      setValidTill(`${daysRemaining} days`);
      setIsValidTenant(true);
    } catch (e) {
      console.error("Error fetching tenant validity:", e);
      setIsValidTenant(false);
    }
  }

  useEffect(() => {
    getExpiryInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadStuffs]);

  // Define primary and secondary navigation items
  const primaryNavItems = [
    { navItem: "Reads", to: "/reads", icon: Package2, color: "green" },
    { navItem: "Write", to: "/writes", icon: Rocket, color: "red" },
  ];

  const secondaryNavItems = [
    // { navItem: "Register", to: "/register", icon: UserPlus, color: "blue" },
  ];

  // Add "Receipt" for courier app
  if (app === "courier") {
    secondaryNavItems.push({
      navItem: "Receipt",
      to: "https://receipt-courier.vercel.app",
      icon: Package2,
      color: "teal",
      external: true, // Indicates external link
    });
  }

  // Function to handle sidebar toggle
  const toggleSidebar = () => {
    setSidebar(!sidebar);
  };

  // Function to handle navigation item click
  const handleItemClick = (item) => {
    if (!item.external) {
      navigate(item.to);
    } else {
      window.open(item.to, "_blank");
    }
    setSidebar(false); // Auto-collapse sidebar on selection
  };

  return (
    <header className="sticky top-0 z-50 flex h-16 items-center justify-between gap-4 border-b bg-background px-4 md:px-6 shadow-md">
      {/* Left side: Primary Navigation Items (Reads and Write) */}
      {(
          <div className="flex items-center gap-5 lg:gap-6 text-sm font-medium">
            {/* {window.location.pathname !== "/topup" &&  window.location.pathname !== "/deployer" && window.location.pathname !== "/login" && window.location.pathname !== "/login" && window.location.pathname !== "/" &&   window.location.pathname !== "/renew" &&   window.location.pathname !== "/register" && primaryNavItems.map((item, i) => {
              // Determine the color based on navItem
              let textColor = "text-muted-foreground";
              let hoverColor = "hover:text-foreground";

              if (item.color === "green") {
                textColor = "text-green-500";
                hoverColor = "hover:text-green-400";
              } else if (item.color === "red") {
                textColor = "text-red-500";
                hoverColor = "hover:text-red-400";
              }

              return (
                <NavLink
                  key={i}
                  to={item.to}
                  className={({ isActive }) =>
                    isActive
                      ? `font-bold ${textColor} ${hoverColor} cursor-pointer flex items-center gap-1`
                      : `${textColor} ${hoverColor} cursor-pointer flex items-center gap-1`
                  }
                >
                  <item.icon className="h-5 w-5" />
                  <span className="inline">{item.navItem}</span>
                </NavLink>
              );
            })} */}


             {   primaryNavItems.map((item, i) => {
              // Determine the color based on navItem
              let textColor = "text-muted-foreground";
              let hoverColor = "hover:text-foreground";

              if (item.color === "green") {
                textColor = "text-green-500";
                hoverColor = "hover:text-green-400";
              } else if (item.color === "red") {
                textColor = "text-red-500";
                hoverColor = "hover:text-red-400";
              }

              return (
                <NavLink
                  key={i}
                  to={item.to}
                  className={({ isActive }) =>
                    isActive
                      ? `font-bold ${textColor} ${hoverColor} cursor-pointer flex items-center gap-1`
                      : `${textColor} ${hoverColor} cursor-pointer flex items-center gap-1`
                  }
                >
                  <item.icon className="h-5 w-5" />
                  <span className="inline">{item.navItem}</span>
                </NavLink>
              );
            })}

            {/* Secondary Navigation Items (Desktop Only) */}
            <div className="hidden md:flex items-center gap-5 lg:gap-6 text-sm font-medium">
              {secondaryNavItems.map((item, i) => {
                let textColor = "text-muted-foreground";
                let hoverColor = "hover:text-foreground";

                if (item.color === "indigo") {
                  textColor = "text-indigo-500";
                  hoverColor = "hover:text-indigo-400";
                } else if (item.color === "blue") {
                  textColor = "text-blue-500";
                  hoverColor = "hover:text-blue-400";
                } else if (item.color === "yellow") {
                  textColor = "text-yellow-500";
                  hoverColor = "hover:text-yellow-400";
                } else if (item.color === "purple") {
                  textColor = "text-purple-500";
                  hoverColor = "hover:text-purple-400";
                } else if (item.color === "teal") {
                  textColor = "text-teal-500";
                  hoverColor = "hover:text-teal-400";
                }

                return (
                  <NavLink
                    key={i}
                    to={item.to}
                    target={item.external ? "_blank" : "_self"}
                    rel={item.external ? "noopener noreferrer" : undefined}
                    className={({ isActive }) =>
                      isActive
                        ? `font-bold ${textColor} ${hoverColor} cursor-pointer flex items-center gap-1`
                        : `${textColor} ${hoverColor} cursor-pointer flex items-center gap-1`
                    }
                  >
                    <item.icon className="h-5 w-5" />
                    <span className="inline">{item.navItem}</span>
                  </NavLink>
                );
              })}
            </div>
          </div>
        )}

      {/* Right side: Tenant Info and Mobile Menu */}
      <div className="flex items-center gap-4">
        {/* Tenant Info (Desktop Only) */}
        {is_valid_tenant && (
          <div className="hidden md:flex items-center gap-2 p-2 bg-gray-50 text-gray-900 rounded-lg shadow-sm border border-gray-200">
            <Package2 className="h-5 w-5 text-[#2B5DF5]" />
            <div>
              <p className="text-sm">
                Tenant ID:{" "}
                <span className="font-semibold">
                  {localStorage.getItem("tenantId")?.length < 10
                    ? localStorage.getItem("tenantId")
                    : `${localStorage.getItem("tenantId")?.substring(0, 10)}...`}
                </span>
              </p>
              <p className="text-sm text-red-500">
                Expires in: <span className="font-semibold">{valid_till}</span>
              </p>
            </div>
          </div>
        )}

        {/* Mobile Sidebar Trigger */}
        {window.location.pathname !== "/login" &&
          window.location.pathname !== "/" &&
          window.location.pathname !== "/renew" && (
            <Sheet open={sidebar}>
              <SheetTrigger asChild>
                <Button
                  variant="outline"
                  size="icon"
                  className="shrink-0 md:hidden"
                  onClick={toggleSidebar}
                  aria-label={sidebar ? "Close sidebar" : "Open sidebar"}
                >
                  {sidebar ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
                </Button>
              </SheetTrigger>
              <SheetContent side="left" className="w-64 bg-white border-r border-gray-200">
                <nav className="flex flex-col gap-6 text-lg font-medium">
                  <div className="flex items-center justify-between">
                    <NavLink
                      to="/"
                      className="flex items-center gap-2 text-lg font-semibold text-gray-900 hover:text-[#2B5DF5] transition-colors"
                      onClick={() => setSidebar(false)}
                    >
                      <Package2 className="h-6 w-6" />
                      <span>Dashboard</span>
                    </NavLink>
                    <Button
                      variant="outline"
                      size="icon"
                      onClick={() => setSidebar(false)}
                      aria-label="Close sidebar"
                      className="border-gray-300"
                    >
                      <X className="h-5 w-5" />
                    </Button>
                  </div>

                  {/* Secondary Navigation Items */}
                  {secondaryNavItems.map((item, i) => (
                    <NavLink
                      key={i}
                      to={item.to}
                      target={item.external ? "_blank" : "_self"}
                      rel={item.external ? "noopener noreferrer" : undefined}
                      onClick={() => handleItemClick(item)}
                      className={({ isActive }) =>
                        isActive
                          ? `font-bold block text-[#2B5DF5] bg-blue-50 rounded py-2 px-4 flex items-center gap-2`
                          : `block text-gray-700 hover:bg-gray-100 hover:text-gray-900 rounded py-2 px-4 flex items-center gap-2`
                      }
                    >
                      <item.icon className="h-5 w-5" />
                      <span>{item.navItem}</span>
                    </NavLink>
                  ))}

                  {/* Tenant Info in Sidebar */}
                  {is_valid_tenant && (
                    <div className="mt-6 p-4 bg-gray-50 rounded-lg flex items-center gap-2 border border-gray-200">
                      <Package2 className="h-5 w-5 text-[#2B5DF5]" />
                      <div>
                        <p className="text-sm text-gray-600">
                          TID:
                          <span className="font-semibold text-gray-900 ml-1">
                            {localStorage.getItem("tenantId").length < 7
                              ? localStorage.getItem("tenantId")
                              : `${localStorage.getItem("tenantId").substring(0, 7)}...`}
                          </span>
                        </p>
                        <p className="text-sm text-gray-600">
                          Expires in:
                          <span className="font-semibold text-red-500 ml-1">
                            {valid_till}
                          </span>
                        </p>
                      </div>
                    </div>
                  )}

                  {/* A logout button  */}
                  <Button
                    variant="outline"
                    size="lg"
                    className="mt-6 border-gray-300 text-gray-700 hover:bg-gray-100"
                    onClick={() => {
                      localStorage.clear();
                      navigate("/login");
                    }}
                  >
                    Logout
                  </Button>
                </nav>
              </SheetContent>
            </Sheet>
          )}
      </div>

      {/* Tenant Info (Hidden on Mobile, already in sidebar) */}
    </header>
  );
};

export default Navbar;
